import { render, staticRenderFns } from "./tuikuanK.vue?vue&type=template&id=00aaf7c2&scoped=true&"
import script from "./tuikuanK.vue?vue&type=script&lang=js&"
export * from "./tuikuanK.vue?vue&type=script&lang=js&"
import style0 from "./tuikuanK.vue?vue&type=style&index=0&id=00aaf7c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aaf7c2",
  null
  
)

export default component.exports